export default "__VITE_ASSET__7a979030__"